angular.module('unica_social_stream.social_stream_controllers')

.controller('SocialStreamListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	Lightbox,
	SocialStreamListService, SocialStreamDeleteService
) {

	$scope.socialStreamList = [];
	$scope.lbSocialStreamList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadSocialStreams = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		SocialStreamListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					for ( var i = 0; i < data.length; i++ ) {
						if ( data[i].channel == 'youtube' ) {
							$scope.lbSocialStreamList.push({
								id: data[i].id,
								title: data[i].title,
								type: 'video',
								thumbUrl: data[i].image_url,
								url: data[i].original_url,
							});
						} else if ( data[i].image_url ) {
							$scope.lbSocialStreamList.push({
								id: data[i].id,
								title: data[i].title,
								thumbUrl: data[i].image_url,
								url: data[i].image_url,
							});
						} else {
							$scope.lbSocialStreamList.push({
								id: data[i].id,
								title: data[i].title
							});
						}
					}

					$scope.socialStreamList = $scope.socialStreamList.concat( data );

					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};


	// $scope.openLightboxModal = function (index) {
	// 	Lightbox.openModal( $scope.lbSocialStreamList, index );
	// };


	$scope.deleteSocialStream = function(postId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare il post?',
			text: 'Confermi la cancellazione del post?'
		}).then(function() {

			$scope.showLoader();
			SocialStreamDeleteService
				.delete( postId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.socialStreamList, function(post, key) {
							if ( post.id == postId ) {
								$scope.socialStreamList.splice(key, 1);
								$scope.lbSocialStreamList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Post eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

})


// .controller('LightboxController', function ($rootScope, $scope, Lightbox) {
//
// 	$scope.hideDeleteMedia = true;
//
// })

;